import configData from "../config.json";
import React from "react";
import { setUserSession } from "../components/Session";
import SlideButton from "react-slide-button";
import biglogo from "../assets/biglogo.png";

const SignIn = () => {
    let u = localStorage.getItem("WBU") || "";
    let p = localStorage.getItem("WBP") || "";
    const [username, setUsername] = React.useState(u);
    const [password, setPassword] = React.useState(p);
    const [fail, setFail] = React.useState(false);
    const [reset, setReset] = React.useState(0);
    const [theme, setTheme] = React.useState("dark"); // "light" or "dark"
    const [loginSuccess, setLoginSuccess] = React.useState(false);
    const [showPassword, setShowPassword] = React.useState(false);
    const [confettiPieces, setConfettiPieces] = React.useState([]);

    React.useEffect(() => {
        if (u !== "" && p !== "") {
            submitted();
        }
    }, []);

    const spawnConfetti = () => {
        const pieces = Array.from({ length: 20 }).map(() => ({
            id: Math.random().toString(36).substr(2, 9),
            left: Math.random() * 320 + "px",
            animationDelay: Math.random() + "s",
            backgroundColor: `hsl(${Math.random() * 360}, 80%, 60%)`,
        }));
        setConfettiPieces(pieces);
        setTimeout(() => setConfettiPieces([]), 1600);
    };

    const submitted = async () => {
        try {
            var url = `${configData.SERVER_URL}apiV7/Auth`;

            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                mode: "cors",
                body: JSON.stringify({
                    username,
                    password,
                }),
            });

            if (response.ok) {
                setFail(false);
                setLoginSuccess(true);
                spawnConfetti(); // trigger confetti on success!
                const data = await response.json();
                setUserSession(data);
                if (data.autologin) {
                    localStorage.setItem("WBU", username);
                    localStorage.setItem("WBP", password);
                } else {
                    localStorage.setItem("WBU", "");
                    localStorage.setItem("WBP", "");
                }
                setTimeout(() => {
                    window.location.href = data.initialPage;
                }, 1500);
            } else {
                setFail(true);
                localStorage.setItem("WBU", "");
                localStorage.setItem("WBP", "");
                setReset((counter) => counter + 1);
                console.error("Login failed");
            }
        } catch (error) {
            setReset((counter) => counter + 1);
            console.error("Login error:", error);
        }
    };

    const toggleTheme = () => {
        setTheme((curr) => (curr === "dark" ? "light" : "dark"));
    };

    const toggleShowPassword = () => {
        setShowPassword((v) => !v);
    };

    return (
        <>
            <style>{`
        /* Reset & base */
        * {
          box-sizing: border-box;
        }
        body, html, #root {
          margin: 0; 
          padding: 0; 
          height: 100vh; /* full viewport height */
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
          transition: background 0.5s ease, color 0.5s ease;
          overflow: hidden;

          /* flex center */
          display: flex;
          justify-content: center;
          align-items: center;
        }

        /* Background gradients */
        .background {
          position: fixed;
          width: 100%;
          height: 100%;
          top: 0; left: 0;
          z-index: -1;
          transition: background 0.5s ease;
        }
        .background.dark {
          background: linear-gradient(45deg, #a299d9, #7aa6d9, #80cfdc, #80ddb2);
          background-size: 800% 800%;
          animation: gradientShift 15s ease infinite;
          color: white;
        }
        .background.light {
          background: linear-gradient(45deg, #e6e0f3, #c8def5, #d8eefb, #caf3e6);
          background-size: 800% 800%;
          animation: gradientShift 15s ease infinite;
          color: #222;
        }

        @keyframes gradientShift {
          0% {
            background-position: 0% 50%;
          }
          50% {
            background-position: 100% 50%;
          }
          100% {
            background-position: 0% 50%;
          }
        }

        /* Container */
        .form-container {
          border-radius: 18px;
          box-shadow: 0 12px 40px rgba(0,0,0,0.25);
          width: 360px;
          max-width: 90vw;
          padding: 45px 35px 55px;
          display: flex;
          flex-direction: column;
          align-items: center;
          transition: background 0.5s ease, color 0.5s ease;
          user-select: none;
          position: relative;
          backdrop-filter: blur(12px);
          -webkit-backdrop-filter: blur(12px);
          margin: 0; /* Remove margin to prevent offset */
        }
        .form-container.dark {
          background: rgba(0,0,0,0.45);
          color: white;
        }
        .form-container.light {
          background: rgba(255, 255, 255, 0.8);
          box-shadow: 0 12px 40px rgba(0,0,0,0.1);
          color: #222;
        }

        /* Logo */
        img.logo {
          width: 160px;
          margin-bottom: 22px;
          filter: drop-shadow(0 3px 6px rgba(0,0,0,0.3));
          user-select: none;
        }

        /* Heading */
        h1 {
          margin: 0 0 34px;
          font-weight: 700;
          letter-spacing: 1.4px;
          user-select: none;
        }

        /* Inputs */
        input[type="text"],
        input[type="password"] {
          width: 100%;
          padding: 14px 48px 14px 18px;
          margin: 10px 0 24px;
          border-radius: 12px;
          border: none;
          font-size: 17px;
          transition: background 0.3s ease, color 0.3s ease, box-shadow 0.3s ease;
          outline: none;
          box-shadow: inset 0 0 8px rgba(0,0,0,0.25);
          user-select: text;
          position: relative;
          font-weight: 500;
          font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
        }
        .form-container.light input[type="text"],
        .form-container.light input[type="password"] {
          background: #fafafa;
          color: #222;
          box-shadow: inset 0 0 12px rgba(0,0,0,0.07);
        }
        .form-container.dark input[type="text"],
        .form-container.dark input[type="password"] {
          background: #22303f;
          color: white;
          box-shadow: inset 0 0 10px rgba(0,0,0,0.5);
        }
        input[type="text"]::placeholder,
        input[type="password"]::placeholder {
          color: #bbb;
          font-weight: 400;
        }
        input[type="text"]:focus,
        input[type="password"]:focus {
          box-shadow: inset 0 0 14px #6a78ff;
        }

        /* Show/hide password icon */
        .password-wrapper {
          width: 100%;
          position: relative;
          margin-bottom: 24px;
        }
        .toggle-password {
          position: absolute;
          top: 50%;
          right: 16px;
          transform: translateY(-50%);
          cursor: pointer;
          color: #999;
          font-size: 20px;
          user-select: none;
          transition: color 0.3s ease;
        }
        .toggle-password:hover {
          color: #555;
        }
        .form-container.light .toggle-password {
          color: #666;
        }

        /* Error message */
        h6.error-msg {
          color: #ff4d6d;
          margin: -15px 0 18px;
          font-weight: 600;
          font-size: 1rem;
          user-select: none;
          letter-spacing: 0.05em;
        }

        /* Slide Button container */
        .slide-container {
          width: 100%;
          background: transparent;
          border-radius: 40px;
          padding: 8px;
          user-select: none;
          overflow: visible;
          position: relative;
        }

        /* SlideButton animated gradient background WITHOUT GREEN */
        .slide-submit {
          background: linear-gradient(270deg, #7b2ff7, #00d2ff, #f107a3);
          background-size: 600% 600%;
          animation: gradientShift 10s ease infinite;
          border-radius: 40px;
          position: relative;
          overflow: hidden;
          cursor: pointer;
        }

        /* Glow effect on slider caret */
        .slide-submit .slider-caret {
          transition: box-shadow 0.3s ease;
          border: none;
        }

        .slide-submit .slider-caret:active,
        .slide-submit .slider-caret:hover {
          box-shadow: 0 0 15px 5px rgba(241, 7, 163, 0.7);
          cursor: grabbing;
        }

        /* SlideButton main text */
        .slide-submit .slider-text {
          color: #7b2ff7;
          font-weight: 700;
          font-size: 1.1rem;
          user-select: none;
          letter-spacing: 0.04em;
          text-align: center;
          line-height: 48px;
        }
        .slide-submit .slider-text--overlay {
          color: #f107a3;
          font-weight: 700;
          font-size: 1.2rem;
        }

        /* Confetti container */
        .confetti-container {
          position: absolute;
          width: 100%;
          height: 100%;
          pointer-events: none;
          overflow: visible;
          top: 0;
          left: 0;
          z-index: 10;
        }

        /* Confetti pieces */
        .confetti {
          position: absolute;
          width: 8px;
          height: 8px;
          opacity: 0.9;
          border-radius: 2px;
          animation: confetti-fall 1.5s ease forwards;
        }

        @keyframes confetti-fall {
          0% {
            opacity: 1;
            transform: translateY(0) rotate(0deg);
          }
          100% {
            opacity: 0;
            transform: translateY(80px) rotate(360deg);
          }
        }

        /* Footer */
        footer {
          margin-top: 36px;
          text-align: center;
          font-size: 1rem;
          user-select: none;
          color: inherit;
        }
        footer a {
          color: inherit;
          text-decoration: none;
          font-weight: 600;
          margin: 0 14px;
          transition: color 0.3s ease;
        }
        footer a:hover {
          text-decoration: underline;
          color: #f107a3;
        }

        /* Theme toggle button (icons only) */
        .theme-toggle {
          position: fixed;
          top: 22px;
          right: 22px;
          background: transparent;
          border: 2px solid;
          border-color: white;
          border-radius: 22px;
          padding: 7px 14px;
          color: white;
          font-weight: 600;
          cursor: pointer;
          user-select: none;
          transition: all 0.3s ease;
          z-index: 100;
          font-size: 1.4rem;
          line-height: 1;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .theme-toggle.light {
          border-color: #444;
          color: #444;
        }
        .theme-toggle:hover {
          background: rgba(255, 255, 255, 0.2);
        }

        /* Success animation */
        .fade-in-success {
          animation: fadeInScale 1.5s ease forwards;
          color: #4CAF50;
          font-weight: 700;
          font-size: 1.25rem;
          margin-top: 16px;
          user-select: none;
          letter-spacing: 0.06em;
        }
        @keyframes fadeInScale {
          0% {
            opacity: 0;
            transform: scale(0.85);
          }
          100% {
            opacity: 1;
            transform: scale(1);
          }
        }
      `}</style>

            {/* Background gradient */}
            <div className={`background ${theme}`} />

            {/* Theme toggle button with icons */}
            <button
                className={`theme-toggle ${theme === "light" ? "light" : ""}`}
                onClick={toggleTheme}
                aria-label="Toggle light/dark theme"
                title={theme === "dark" ? "Switch to Light Mode" : "Switch to Dark Mode"}
            >
                {theme === "dark" ? "🌞" : "🌜"}
            </button>

            {/* Form container */}
            <div className={`form-container ${theme}`}>
                <img src={biglogo} alt="EZYweigh" className="logo" />
                <h1>Sign In</h1>
                <input
                    required
                    type="text"
                    placeholder="User Name"
                    name="username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    autoComplete="username"
                />
                <div className="password-wrapper">
                    <input
                        required
                        type={showPassword ? "text" : "password"}
                        placeholder="Password"
                        name="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        autoComplete="current-password"
                    />
                    <span
                        className="toggle-password"
                        onClick={toggleShowPassword}
                        role="button"
                        aria-label={showPassword ? "Hide password" : "Show password"}
                        tabIndex={0}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                toggleShowPassword();
                            }
                        }}
                    >
                        {showPassword ? "🙈" : "👁️"}
                    </span>
                </div>
                {fail && <h6 className="error-msg">Invalid User Name or Password</h6>}

                <div className="slide-container" style={{ position: "relative" }}>
                    <SlideButton
                        className="slide-submit"
                        mainText="Slide to Enter"
                        overlayText="Let's Go! 🚀"
                        caretClassList="slider-caret"
                        overlayClassList="slider-text--overlay"
                        onSlideDone={submitted}
                        reset={reset}
                    />
                    <div className="confetti-container">
                        {confettiPieces.map(({ id, left, animationDelay, backgroundColor }) => (
                            <div
                                key={id}
                                className="confetti"
                                style={{
                                    left,
                                    animationDelay,
                                    backgroundColor,
                                }}
                            />
                        ))}
                    </div>
                </div>

                {loginSuccess && (
                    <div className="fade-in-success">Login Successful!</div>
                )}
            </div>

            <footer>
                <p>
                    &nbsp;&nbsp;&nbsp;
                    <a href="https://wms.screenconnect.com" target="_blank" rel="noreferrer">
                        <b>Remote support</b>
                    </a>
                    &nbsp;&nbsp;&nbsp;
                    <a href="https://weigh-more.com.au/contact/" target="_blank" rel="noreferrer">
                        <b>Contact us</b>
                    </a>
                    &nbsp;&nbsp;&nbsp;
                    <a href="https://weigh-more.com.au/about-us/" target="_blank" rel="noreferrer">
                        <b>About</b>
                    </a>
                </p>
            </footer>
        </>
    );
};

export default SignIn;
